import styled from 'styled-components'

export const Container = styled.section`
    float: left;
    width: 100%;
    position: relative;
    background-color: #171850;
    padding: 100px 60px;
    display: flex;
    justify-content: center;
    border-top: solid 5px #202156;
    border-bottom: solid 5px #202156;

    @media (max-width: 1000px) {
        padding: 50px 20px 50px 20px;
    }
`

export const ContainerInterno = styled.div`
    display: inline-block;
    max-width: 1436px;
`

export const TituloPrincipal = styled.span`
    float: left;
    width: 100%;
    color: #FFFFFF;
    font-size: 30px;
    line-height: 40px;
    font-weight: 900;
    margin: 0 0 15px 0;
    text-align: center;

    strong {
        color: #EFBD5E;
    }

    @media (max-width: 768px) {
        font-size: 22px;
        line-height: 32px;

        br {
            display: none;
        }
    }
`

export const Subtitulo = styled.span`
    float: left;
    width: 100%;
    color: #C3C9E6;
    font-size: 16px;
    line-height: 26px;
    font-weight: 700;
    margin: 0 0 50px 0;
    text-align: center;

    @media (max-width: 768px) {
        margin: 0 0 40px 0;

        br {
            display: none;
        }
    }
`

export const ListaConteudos = styled.ul`
    float: left;
    width: 100%;
    margin: 0;
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 20px;
    padding: 0;

    @media only screen and (max-width: 900px) {
        grid-template-columns: repeat(2, 1fr);
    }

    @media only screen and (max-width: 500px) {
        grid-template-columns: repeat(1, 1fr);
    }
`

export const ListaConteudosItem = styled.li`
    list-style: none;
    background: rgb(255, 255, 255, 0.05);
    border: solid 1px #575757;
    border-radius: 14px;
    padding: 30px 20px;
    display: flex;
    align-items: center;
    flex-direction: column;

    &.lastItem {
        border: solid 2px #EFBD5E;
    }
`

export const ValorAte = styled.span`
    color: #C3C9E6;
    text-align: center;
    font-size: 14px;
    line-height: 14px;
`

export const Porcentagem = styled.span`
    color: #EFBD5E;
    text-align: center;
    font-size: 40px;
    line-height: 40px;
    margin: 7px 0;
    font-weight: 900;
`

export const Legenda = styled.span`
    color: #C3C9E6;
    text-align: center;
    font-size: 14px;
    line-height: 14px;
`